import { render, staticRenderFns } from "./PopupReplaceDocuments.vue?vue&type=template&id=2fa0e91e"
import script from "./PopupReplaceDocuments.vue?vue&type=script&lang=ts"
export * from "./PopupReplaceDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports